import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatBadgeModule } from '@angular/material/badge';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule({
    imports: [
        NgxSkeletonLoaderModule,
        BrowserAnimationsModule,
        MatStepperModule,
        MatChipsModule,
        MatListModule,
        MatSidenavModule,
        MatToolbarModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatTableModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatSortModule,
        MatRippleModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatBadgeModule,
        MatOptionModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule,
        MatExpansionModule
    ],
    exports: [
        //Modules
        NgxSkeletonLoaderModule,
        MatStepperModule,
        MatChipsModule,
        MatListModule,
        MatSidenavModule,
        MatDividerModule,
        MatToolbarModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatTableModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatBadgeModule,
    ]
})
export class CustomMaterialModule {
    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon(
            'partnershipCert',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '/assets/img/partnershipCert.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'certification',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '/assets/svg-icons/certification.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'prio-product',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/svg-icons/prio_product_icon.svg'
            )
        );
    }
}
